<template>
  <div class="myincomeChange">
    <toptitle :title1="titlework" />
    <div>
      <div class="info" v-for="item in info">{{ item }}</div>
    </div>
    <div class="hint">{{ hint }}</div>
  </div>
</template>

<script>
  import toptitle from '../components/toptitle';
  import { GetMyIncomeChangeDataApi } from '../request/api';

  export default {
    name: 'myincomeChange',
    data() {
      return {
        titlework: '我的薪酬异动',
        pwd: '',
        infoId: '',
        info: '',
        hint: ''
      };
    },
    components: {
      toptitle
    },
    created() {
      this.pwd = this.$route.query.param;
      this.infoId = this.$route.query.infoId;
    },
    mounted() {
      this.getInfo();
    },
    methods: {
      getInfo() {
        if (this.pwd == ' ') {
          this.$router.push('/login');
        }
        let params = {
          EMPLID: sessionStorage.getItem('EMPLID'),
          PASSWORD: this.pwd,
          MSG_ID: this.infoId
        };
        GetMyIncomeChangeDataApi(params).then(res => {
          if (res.CODE === 200) {
            const data = res.DATA[0];
            this.info = data.C_MSG.split('\n');
            this.hint = data.C_DESCR254;
          }
        });
      }
    }
  };
</script>

<style lang="less" scoped>
  .info {
    margin: 20px;
    text-indent: 2rem;
    line-height: 30px;
  }
  .hint {
    margin: 20px;
    // text-indent: 2rem;
    line-height: 26px;
    color: red;
  }
</style>
